import React from 'react';

const ProdutoContext = React.createContext();

export const IMAGES_ACTION_TYPES = {
    UPDATE_IMAGES: 'UPDATE_IMAGES',
    DELETE_INDEX: 'DELETE_INDEX'
};

export const INITIAL_STATE = {
    images: []
};

function produtoReducer(state, action) {
    switch (action.type) {
        case 'UPDATE_IMAGES': {
            const { idProduto } = state;
            return { idProduto, images: [...action.payload] };
        }
        case 'DELETE_INDEX': {
            const { index: indexToDelete } = action.payload;

            const newState = [...state.images].filter((_, index) => {
                return index !== indexToDelete;
            });

            return { ...state, images: newState };
        }

        default: {
            throw new Error(`Reducer: Unhandled action type: ${action.type}`);
        }
    }
}

function ProdutoProvider({ children, initialState = INITIAL_STATE }) {
    const [store, dispatch] = React.useReducer(produtoReducer, initialState);

    const contextValue = React.useMemo(() => [store, dispatch], [store]);

    return (
        <ProdutoContext.Provider value={contextValue}>
            {children}
        </ProdutoContext.Provider>
    );
}

function useProduto() {
    const context = React.useContext(ProdutoContext);
    return context;
}

export { ProdutoProvider, useProduto };
